import { Badge } from '@/components/ui/badge'
import { Skeleton } from '@/components/ui/skeleton'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import type { EmployeeOrder } from '@/types/employee'
import { commissionTypeLabels, commissionStatusLabels } from '@/types/employee'

interface OrderTableProps {
  orders: EmployeeOrder[]
  isLoading: boolean
  onSelectOrder: (orderId: number) => void
}

export function OrderTable({ orders, isLoading, onSelectOrder }: OrderTableProps) {
  if (isLoading) {
    return (
      <div className="rounded-lg border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>订单编号</TableHead>
              <TableHead>客户姓名</TableHead>
              <TableHead>客户手机号</TableHead>
              <TableHead>订单金额</TableHead>
              <TableHead>下单时间</TableHead>
              <TableHead>我的佣金</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: 5 }).map((_, i) => (
              <TableRow key={i}>
                {Array.from({ length: 6 }).map((_, j) => (
                  <TableCell key={j}>
                    <Skeleton className="h-5 w-full" />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    )
  }

  if (orders.length === 0) {
    return (
      <div className="flex items-center justify-center rounded-lg border bg-card py-12">
        <p className="text-muted-foreground">暂无订单数据</p>
      </div>
    )
  }

  const statusVariant = (status: number) => {
    if (status === 1) return 'default' as const
    if (status === 2) return 'destructive' as const
    return 'secondary' as const
  }

  return (
    <div className="rounded-lg border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>订单编号</TableHead>
            <TableHead>客户姓名</TableHead>
            <TableHead>客户手机号</TableHead>
            <TableHead className="text-right">订单金额</TableHead>
            <TableHead>下单时间</TableHead>
            <TableHead className="text-right">我的佣金</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {orders.map((order) => (
            <TableRow
              key={order.id}
              className="cursor-pointer hover:bg-muted/50"
              onClick={() => onSelectOrder(order.order_id)}
            >
              <TableCell className="font-medium">{order.order_no}</TableCell>
              <TableCell>{order.real_name || '-'}</TableCell>
              <TableCell>{order.user_phone || '-'}</TableCell>
              <TableCell className="text-right">¥{order.pay_price.toFixed(2)}</TableCell>
              <TableCell>{order.pay_time}</TableCell>
              <TableCell className="text-right">
                <div className="flex items-center justify-end gap-2">
                  <span>¥{order.my_effective_amount.toFixed(2)}</span>
                  {order.my_commission_type && (
                    <Badge variant="outline" className="text-xs">
                      {commissionTypeLabels[order.my_commission_type]}
                    </Badge>
                  )}
                  {order.my_status !== 1 && (
                    <Badge variant={statusVariant(order.my_status)} className="text-xs">
                      {commissionStatusLabels[order.my_status as keyof typeof commissionStatusLabels]}
                    </Badge>
                  )}
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
